import { assert } from '@awayjs/graphics';
import { release, notImplemented, hasOwnGetter } from '@awayfl/swf-loader';
import { containsSymbol } from './containsSymbol';
export function linkSymbols(symbols, traits, object) {
    for (var i = 0; i < traits.traits.length; i++) {
        var trait = traits.traits[i];
        if (!containsSymbol(symbols, trait.getName().name)) {
            continue;
        }
        release || assert(trait.getName().namespace.type !== 3 /* Private */, 'Why are you linking against private members?');
        if (trait.isConst()) {
            release || release || notImplemented('Don\'t link against const traits.');
            return;
        }
        var name_1 = trait.getName().name;
        var qn = trait.getName().getMangledName();
        if (trait.isSlot()) {
            Object.defineProperty(object, name_1, {
                get: new Function('', 'return this.' + qn +
                    '//# sourceURL=get-' + qn + '.as'),
                set: new Function('v', 'this.' + qn + ' = v;' +
                    '//# sourceURL=set-' + qn + '.as')
            });
        }
        else if (trait.isGetter()) {
            release || assert(hasOwnGetter(object, qn), 'There should be an getter method for this symbol.');
            Object.defineProperty(object, name_1, {
                get: new Function('', 'return this.' + qn +
                    '//# sourceURL=get-' + qn + '.as')
            });
        }
        else {
            notImplemented(trait.toString());
        }
    }
}
